export default __webpack_public_path__ + "static/media/video1.b911eb94.png";